<template>
    <div class="fullSwiper">
        <swiper ref="swiper" :options="Options">
            <swiper-slide v-for="(item, index) in data" :key="index">
                <div class="cover" :style="`background-image: url(${item});`"></div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: "fullSwiper",
    props: ['data'],
    data() {
        return {
            Options: {
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                loop: true,
                autoplay: {
                    disableOnInteraction: false,
                },
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.$swiper
        },
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.fullSwiper{
    width: 100%;
    height: 100%;
    position: relative;
    .swiper-container{
        width: 100%;
        height: 100%;
        .cover{
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }
    }
}
</style>